<section class="article-component-cont">
  <header>
    <h3 class="ent-color"><i class="fas fa-user-tie" aria-hidden="true"></i>Agent information</h3>
  </header>
  <div class="article-content agent-info">
    @if (agentData()?.length <= 3) {
      <section>
        <div class="agent-info__grid">
          @for (agent of agentData(); track agent) {
            <div class="agent-info__row">
              <p><strong>{{ agent.AgentName }}</strong></p>
            </div>
          }
        </div>
      </section>
    }
    <!-- agent information table -->
    <ng-content></ng-content>
  </div>
</section>
